import { Text } from '@nike/eds'
import { TrinityButton } from 'components/trinity-button'
import { useTranslation } from 'react-i18next'
import { GradeKey } from 'types'
import { type GradingInstruction } from 'types/GradingInstruction'

interface MainGradesProps {
  handleGradeChange: (newGrade: GradeKey) => void
  activeGrade: GradeKey | undefined
  hashable: boolean
  aGradable: boolean
  bGradable: boolean
  cGradable: boolean
  sGradable: boolean
  instruction: GradingInstruction | undefined
}

export const MainGradeButtons = ({ handleGradeChange, activeGrade, hashable, aGradable, bGradable, cGradable, sGradable, instruction }: MainGradesProps) => {
  const { t } = useTranslation()
  const disabledMessage = instruction ? t('grading.disabled_for_sku_message') : t('grading.disabled_message')

  return <>
    <Text font={'display-2'} as={'h1'} className={'mb-6'}>
      {t('grading.grade')}
    </Text>

    <div className={'button-grid'}>
      {hashable
        ? <TrinityButton className={`grid-button full-left ${hashable ? 'background-blue' : 'background-grey'}`}
          active={activeGrade === GradeKey.HASH}
          disabled={!hashable}
          disabledMessage={`${t('grading.hash_grade')} ${disabledMessage}`}
          size={'massive'}
          onClick={() => { handleGradeChange(GradeKey.HASH) }}>
          {t('grading.hash_grade')}
        </TrinityButton>
        : <TrinityButton className={`grid-button full-left ${aGradable ? 'background-green' : 'background-grey'}`}
          active={activeGrade === GradeKey.A_GRADE}
          disabled={!aGradable}
          disabledMessage={`${t('grading.a_grade')} ${disabledMessage}`}
          size={'massive'}
          onClick={() => { handleGradeChange(GradeKey.A_GRADE) }}>
          {t('grading.a_grade')}
        </TrinityButton>
      }
      { sGradable
        ? <TrinityButton className={`grid-button ${sGradable ? 'background-orange' : 'background-grey'}`}
            active={activeGrade === GradeKey.S_GRADE}
            size={'massive'}
            disabled={!sGradable}
            disabledMessage={`${t('grading.s_grade')} ${disabledMessage}`}
            onClick={() => { handleGradeChange(GradeKey.S_GRADE) }}>
             {t('grading.s_grade')}
          </TrinityButton>
        : <TrinityButton className={`grid-button ${bGradable ? 'background-orange' : 'background-grey'}`}
          active={activeGrade === GradeKey.B_GRADE}
          size={'massive'}
          disabled={!bGradable}
          disabledMessage={`${t('grading.b_grade')} ${disabledMessage}`}
          onClick={() => { handleGradeChange(GradeKey.B_GRADE) }}>
           {t('grading.b_grade')}
        </TrinityButton>
      }
          <TrinityButton className={`grid-button ${cGradable ? 'background-red' : 'background-grey'}`}
            active={activeGrade === GradeKey.C_GRADE}
            disabled={!cGradable}
            disabledMessage={`${t('grading.c_grade')} ${disabledMessage}`}
            size={'massive'}
            onClick={() => { handleGradeChange(GradeKey.C_GRADE) }}>
            {t('grading.c_grade')}
          </TrinityButton>
    </div>
  </>
}
